import { queryOptions } from '@tanstack/react-query'
import { getReceiptManagementEnabled } from 'src/queries/organizations/receiptManagement/receiptManagement.network'
import { queryCacheOptions } from 'src/queries/queries.constants'

export const orgReceiptManagementQueryKeys = {
  all: () => ['receiptManagement'] as const,
  enabled: (orgId: string | undefined) =>
    [...orgReceiptManagementQueryKeys.all(), 'enabled', orgId] as const,
}

export const orgReceiptManagementQueries = {
  enabled: (orgId: string | undefined) =>
    queryOptions({
      queryKey: orgReceiptManagementQueryKeys.enabled(orgId),
      queryFn: async () => {
        const data = await getReceiptManagementEnabled(orgId!)
        return data.receiptManagementEnabled
      },
      enabled: Boolean(orgId),
      ...queryCacheOptions(),
    }),
}
